export const environment = {
  production: true,
  apiDomain: 'https://api-accounts.totalum.app/',
  totalumFrontendUrl: 'https://web.totalum.app/',
  // Canonical full API reference (Markdown), generated from the totalum-website
  // docs content. The VCaaS "Download .md" / "Copy for AI" actions fetch this so
  // they always match www.totalum.app/docs instead of duplicating the docs.
  docsMarkdownUrl: 'https://www.totalum.app/totalum-api.md',
  // Target of the CEO dashboard's "Open" action on a project (organizationid appended).
  totalumTablesUrl: 'https://web.totalum.app/table/totalum_instances',
  /**
   * The NEW platform. Signing out of this legacy panel lands the user here rather
   * than back on its own `/login` — the product they should be using now.
   *
   * ⚠️ THE SAME VALUE IN EVERY ENVIRONMENT, ON PURPOSE. There is only one platform
   * deployment; `platform.sp-dev-tot-env.app` does not exist. Same reasoning as
   * `totalumFrontendUrl` pointing local at a deployed app: a dead port is worse
   * than a live app belonging to another environment.
   *
   * ⚠️ IT IS SAFE TO SEND A LEGACY USER THERE. `LegacyHintService.markSignedOut()`
   * runs first and writes `tot_legacy=0`, which suppresses the platform's
   * `/legacy-account` handoff — so they land on its login page, not in a bounce
   * back to here.
   */
  /**
   * ⭐ THE MARKETING SITE. Used by /ceo/templates to build the second, public-facing
   * form of a template launch link: `totalum.app/templates/<alias>`.
   *
   * ⚠️ THE SAME VALUE IN EVERY ENVIRONMENT, like `platformUrl` and for the same
   * reason: there is one marketing deployment, and a template link is something you
   * paste into an email — it has to be the address customers recognise.
   */
  websiteUrl: 'https://totalum.app',
  platformUrl: 'https://platform.totalum.app',
  recaptcha: {
    siteKey: '6LdBZyUoAAAAAPPgxPznOK-B8jAYje5qw6sJHxao'
  },
  stripe: {
    publicKey: 'pk_live_51TUpOPAxSNO5ocYTwSCaxt0K6EQMvOeM85CN70qjy7nud6JZg5BECP8wGdxWurJanXHNEMusn5n6ILPQbYUHFdaU00pHG0ICF1'
  }
};
